import React from 'react';
import { Helmet } from 'react-helmet-async';
import BlogList from '../components/blog/BlogList';
import BlogSearch from '../components/blog/BlogSearch';
import BlogCategories from '../components/blog/BlogCategories';

export default function Blog() {
  return (
    <>
      <Helmet>
        <title>Appliance Repair Blog - Expert Tips & Guides | Parakh Services</title>
        <meta 
          name="description" 
          content="Expert tips, guides, and advice on home appliance repair and maintenance. Learn how to maintain your appliances and when to call professionals." 
        />
      </Helmet>

      <div className="bg-gray-50 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">
              Appliance Care & Maintenance Blog
            </h1>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Expert tips, guides, and advice to help you maintain your home appliances
              and make informed decisions about repairs.
            </p>
          </div>

          <BlogSearch />
          <BlogCategories />
          <BlogList />
        </div>
      </div>
    </>
  );
}